<template>
  <nav class="app-nav">
    <div class="px-0 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div class="relative flex items-center justify-between">
        <div class="absolute inset-y-0 flex items-center left-1 sm:hidden">
          <!-- Mobile menu button-->
          <button
            type="button"
            @click="openMenu"
            class="relative inline-flex items-center justify-center p-2 text-white rounded-md bg-gray-100/20 hover:bg-gray-700/20 hover:text-white focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
          >
            <svg
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              v-show="!showMenu"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
            <svg
              class="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              v-show="showMenu"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="flex items-center justify-center flex-1 sm:items-stretch sm:justify-start">
          <div class="flex items-center flex-shrink-0">
            <router-link to="/home">
              <img class="w-auto h-20" src="~@/assets/images/logo.png" />
            </router-link>
          </div>
          <div class="items-center flex-1 hidden nav-menu sm:flex max-md:ml-6">
            <ul class="flex justify-center py-2 mx-auto space-x-4 lg:space-x-6">
              <router-link
                class=""
                v-for="menu in menuData"
                :key="menu.code"
                tag="li"
                :to="menu.url"
                ><a>{{ menu.name }}</a>
                <div class="dropdown" v-if="menu.child">
                  <ul class="w-40">
                    <router-link
                      v-for="child in menu.child"
                      :key="child.code"
                      tag="li"
                      :to="child.url"
                      ><a>{{ child.name }}</a>
                    </router-link>
                  </ul>
                </div>
              </router-link>
              <li v-if="isLogin" @click="jump"><a>会员中心</a></li>
            </ul>
          </div>
        </div>

        <div
          class="absolute inset-y-0 right-0 flex items-center sm:static sm:inset-auto sm:ml-6 xl:ml-10 sm:pr-0"
        >
          <div class="nav-user">
            <div v-if="!isLogin">
              <i class="iconfont icon-user-outline"></i>
              <router-link to="/login"> 登录</router-link>
              <i class="">|</i>
              <router-link to="/register" class="register">注册</router-link>
            </div>
            <div v-else class="user-img">
              <router-link to="">
                <img :src="userInformation.url || userimg" @click="jump" />
              </router-link>
              {{ userInfo.userLoginName }}
              <div class="user-list">
                <ul>
                  <li @click="jump"><i class="iconfont icon-user-outline"></i>用户中心</li>
                  <li v-on:click="sigout"><i class="iconfont icon-daochu"></i>退出</li>
                </ul>
              </div>
              <div class="logoV" v-if="vipLevel != 0">V</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile menu, show/hide based on menu state. -->
    <div v-show="showMenu" :class="{ 'h-auto': showMenu }" class="nav-scroll-menu">
      <ul class="flex flex-col px-20 mx-10 text-center">
        <li class="my-1.5" v-for="menu in menuData" :key="menu.code">
          <router-link :to="menu.url">{{ menu.name }}</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue'
  import userimg from '@/assets/images/icon-user.png'
  import { useStore, useMessage, useRouter } from '@/utils/vueApi'
  import { Logout } from '@/api/model/user'
  import { companyQuery } from '@/api/model/company'

  const { getters, dispatch } = useStore()
  const router = useRouter()
  const isLogin = computed(() => getters.islogin)
  const userInformation = computed(() => getters.userInfo)
  const showMenu = ref(false)
  function openMenu() {
    showMenu.value = !showMenu.value
  }
  const userInfo = ref({
    userImg: userimg,
  })
  onMounted(() => {
    dispatch('GET_CITYLIST')
    getCompInfo()
  })
  const menuData = ref([
    { name: '首页', code: 'home', url: '/home' },
    {
      name: '运价查询',
      code: 'freight',
      url: '/freight',
      child: [
        {
          name: '整箱运价查询',
          code: 'freightFcl',
          url: '/freight/Fcl',
        },
        {
          name: '拼箱运价查询',
          code: 'freightLcl',
          url: '/freight/Lcl',
        },
        {
          name: '空运运价查询',
          code: 'freightAir',
          url: '/freight/Air',
        },
      ],
    },
    {
      name: '货盘',
      code: 'enquiry',
      url: '/enquiry',
      child: [
        {
          name: '拖车货盘',
          code: 'trailer',
          url: '/enquiry/trailer',
        },
        {
          name: '整箱货盘',
          code: 'enquiryFcl',
          url: '/enquiry/FCL',
        },
        {
          name: '拼箱货盘',
          code: 'enquiryLcl',
          url: '/enquiry/LCL',
        },
        {
          name: '空运货盘',
          code: 'enquiryAir',
          url: '/enquiry/AIR',
        },
      ],
    },
    { name: '物流圈', code: 'supplier', url: '/supplier' },
    // { name: '产品中心', code: 'product', url: '/product' },
    { name: '开通会员', code: 'vipPlan', url: '/vipPlan' },
    { name: '关于我们', code: 'about', url: '/about' },
  ])
  function jump() {
    if (isLogin.value) {
      let url = '/manage/' // + "&password=" + param.password
      window.location.href = url
    } else {
      router.replace({ path: '/login' })
    }
  }
  const Message = useMessage()
  function sigout() {
    Logout().then((res) => {
      Message({
        message: '退出成功',
        type: 'success',
        duration: 1500,
      })
      dispatch('USER_SIGNOUT')
      // router.go(0)
    })
  }

  // 会员等级
  const vipLevel = ref()
  function getCompInfo() {
    companyQuery().then((res) => {
      vipLevel.value = res.vipLevel
    })
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import '@/scss/comm/var.scss';
  @import '@/scss/comm/mixin.scss';
  /*导航样式*/
  .app-nav {
    margin-top: 25px;
    width: 100%;
    z-index: 1;
  }

  .nav-bg {
    background-color: rgba(0, 0, 0, 0.2);
  }
  /**导航logo**/
  .nav-logo {
    position: relative;
  }

  /**导航菜单**/
  .nav-scroll-menu {
    font-size: 1.2rem;
    @include transition(0.5s);
    border: 1px solid rgba(251, 251, 251, 0.5);
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(10px);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    position: absolute;
    top: 100px;
    right: 10px;
    left: 10px;
    z-index: 10;
    height: 0px;
  }
  .nav-menu {
    font-size: 1rem;
    transition: all 0.5s;
  }
  .nav-menu,
  .nav-scroll-menu {
    > ul {
      > li {
        position: relative;
        padding: 5px 10px 7px 10px;
        &:hover {
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
          //background: rgba(0, 0, 0, 0.2);
          .dropdown {
            top: 45px;
            opacity: 1;
            visibility: visible;
          }
        }
        &.link-active {
          border: 1px solid rgba(251, 251, 251, 0.5);
          background-color: rgba(16, 16, 16, 0.3);
          backdrop-filter: blur(10px);
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
          border-radius: 10px;
          > a {
            color: $brand-secondary;
            //color: rgba(255, 255, 255, 1);
          }
        }
        > a {
          font-weight: 400;
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          &:hover {
            //  color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
  }
  .dropdown {
    position: absolute;
    visibility: hidden;
    opacity: 0;
    left: 0;
    top: 80px;
    z-index: 1;
    @include transition(0.5s);
    > ul {
      padding: 4px 10px 12px 10px;
      border: 1px solid rgba(251, 251, 251, 0.5);
      background-color: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(10px);
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
      border-radius: 10px;
      > li {
        margin-top: 8px;
        position: relative;
        padding: 5px 10px;
        &:hover {
          background-color: rgba(0, 0, 0, 0.2);
          border-radius: 10px;
        }
        a {
          color: #333;
        }
      }
    }
  }
  /**导航用户**/

  .nav-user {
    color: rgba(255, 255, 255, 0.8);
    @include transition(0.5s);
    a {
      transition: background-color 0.5s ease, color 0.5s ease;
      color: rgba(255, 255, 255, 0.8);
      margin: 0 3px;
      font-size: 12px;
      &:hover {
        color: $brand-secondary !important;
      }
    }
    .register {
      margin-left: 6px;
      display: inline-block;
      width: 34px;
      height: 20px;
      line-height: 20px;
      background: $brand-secondary;
      text-align: center;
      border-radius: 2px;
      &:hover {
        color: #fff !important;
      }
    }
  }

  .user-img {
    cursor: pointer;
    font-size: 14px;
    position: relative;
    min-width: 90px;
    text-align: center;
    @include border-radius(5px 5px 0 0);
    img {
      border: 4px solid rgba(255, 255, 255, 0.2);
      @include border-radius(50px);
      opacity: 0.8;
      width: 50px;
      height: 50px;
      vertical-align: middle;
    }
    &:hover {
      background: rgba(0, 0, 0, 0.2);
      .user-list {
        display: block;
        height: auto;
      }
    }
    .logoV {
      position: absolute;
      bottom: 2px;
      right: 18px;
      width: 20px;
      height: 20px;
      background-color: #ff9603;
      border-radius: 50%;
    }
  }

  .user-list {
    transition: all 0.5s;
    @include border-radius(0 0 5px 5px);
    height: 0px;
    width: 100%;
    z-index: 2;
    position: absolute;
    left: 0px;
    display: none;
    background: rgba(0, 0, 0, 0.2);
    li {
      padding-left: 10px;
      text-align: left;
      display: block;
      margin: 7px 0;
      padding: 2px 0px 2px 10px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 1.2;
      font-size: 14px;
      &:hover {
        color: $brand-white;
      }
    }
  }

  /* Border X get width  */
  .borderXwidth a:before,
  .borderXwidth a:after {
    position: absolute;
    opacity: 0;
    width: 0%;
    height: 2px;
    transform: scaleY(0.5);
    content: '';
    background: #fff;
    transition: all 0.5s;
  }

  .borderXwidth a:before {
    left: 0px;
    top: 0px;
  }

  .borderXwidth a:after {
    right: 0px;
    bottom: 0px;
  }

  .borderXwidth a:hover:before,
  .borderXwidth a:hover:after {
    opacity: 1;
    width: 100%;
  }
</style>
